import React from 'react';
import {
  Table,
  Input,
  Dropdown,
  Menu,
  Button,
  Icon
} from 'antd';
import StationLinkUpdate from './StationLinkUpdate';
import StationLinkGroupUpdate from './StationLinkGroupUpdate';
import StationLinkDelete from './StationLinkDelete';
import StationLinkCamera from './StationLinkCamera';
import {roleStationManagement} from '../constants/defaultValues';
import {locdau} from '../utils'

const highlight = {
  color: '#003a8c'
}

class StationTableMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stations: this.props.stations,
      nameFilterVisible: false,
      nameSearchText: '',
      nameFiltered: false,
      hardwareIDFilterVisible: false,
      hardwareIDSearchText: '',
      hardwareIDFiltered: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({stations: nextProps.stations})
  }

  handleNameInputChange = (e) => {
    this.setState({nameSearchText: e.target.value});
  };

  handleNameSearch = () => {
    const {nameSearchText} = this.state
    const {stations} = this.props
    const filterStations = stations.filter((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(nameSearchText).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      return index > -1
    }).map((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(nameSearchText).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      const beforeStr = item.Name.substr(0, index);
      const matchStr = item.Name.substr(index, nameSearchText.length);
      const afterStr = item.Name.substr(index + nameSearchText.length);
      const title = (<span>
        {beforeStr}
        <span className="highlight">{matchStr}</span>
        {afterStr}
      </span>)
      return {
        ...item,
        Title: title
      };
    })

    this.setState({
      nameFilterVisible: false,
      nameFiltered: !!nameSearchText,
      hardwareIDFiltered: false,
      hardwareIDSearchText: "",
      stations: filterStations
    });
  };

  handleHardwareIDInputChange = (e) => {
    this.setState({hardwareIDSearchText: e.target.value});
  };

  handleHardwareIDSearch = () => {
    const {hardwareIDSearchText} = this.state
    const {stations} = this.props
    const filterStations = stations.filter((item) => {
      const lower = item.HardwareIDHex.toLowerCase()
      const lowerSearch = hardwareIDSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      return index > -1
    }).map((item) => {
      const lower = item.HardwareIDHex.toLowerCase()
      const lowerSearch = hardwareIDSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      const beforeStr = item.HardwareIDHex.substr(0, index);
      const matchStr = item.HardwareIDHex.substr(index, hardwareIDSearchText.length);
      const afterStr = item.HardwareIDHex.substr(index + hardwareIDSearchText.length);
      const title = (<span>
        {beforeStr}
        <span className="highlight">{matchStr}</span>
        {afterStr}
      </span>)
      return {
        ...item,
        HardwareIDTitle: title
      };
    })
    this.setState({
      hardwareIDFilterVisible: false,
      hardwareIDFiltered: !!hardwareIDSearchText,
      nameFiltered: false,
      nameSearchText: "",
      stations: filterStations
    });
  };

  handleHardwareIDInputChange = (e) => {
    this.setState({hardwareIDSearchText: e.target.value});
  };

  handleDelete = (station) => {
    this.props.onDelete(station)
  }

  handleUpdate = (station) => {
    const {onUpdate} = this.props
    onUpdate(station)
  }

  handleStationButtonCamera = (station) => {
    const {onStationButtonCamera} = this.props
    onStationButtonCamera(station)
  }

  render() {
    const {role, fetching, groups, treeGroups} = this.props
    const {stations, nameFiltered, nameFilterVisible, hardwareIDFiltered, hardwareIDFilterVisible} = this.state

    const columns = [
      {
        title: 'Tên',
        dataIndex: 'Name',
        render: (text, station, i) => (
          station.Title
          ? station.Title
          : station.Name),
        key: 'name',
        filterDropdown: (<div className="table-filter-dropdown">
          <Input ref={ele => this.nameSearchInput = ele} placeholder="Nhập tên" value={this.state.nameSearchText} onChange={this.handleNameInputChange} onPressEnter={this.handleNameSearch}/>
          <Button type="primary" onClick={this.handleNameSearch}>Tìm</Button>
        </div>),
        filterIcon: <Icon type="search" style={nameFiltered
            ? highlight
            : null}/>,
        filterDropdownVisible: nameFilterVisible,
        onFilterDropdownVisibleChange: visible => this.setState({
          nameFilterVisible: visible
        }, () => this.nameSearchInput.focus())
      }, {
        title: 'Mã',
        dataIndex: 'HardwareIDHex',
        render: (text, station, i) => (
          station.HardwareIDTitle
          ? station.HardwareIDTitle
          : station.HardwareIDHex),
        key: 'hardwareidhex',
        filterDropdown: (<div className="table-filter-dropdown">
          <Input ref={ele => this.hardwareIDSearchInput = ele} placeholder="Nhập mã" value={this.state.hardwareIDSearchText} onChange={this.handleHardwareIDInputChange} onPressEnter={this.handleHardwareIDSearch}/>
          <Button type="primary" onClick={this.handleHardwareIDSearch}>Tìm</Button>
        </div>),
        filterIcon: <Icon type="search" style={hardwareIDFiltered
            ? highlight
            : null}/>,
        filterDropdownVisible: hardwareIDFilterVisible,
        onFilterDropdownVisibleChange: visible => this.setState({
          hardwareIDFilterVisible: visible
        }, () => this.hardwareIDSearchInput.focus())
      }, {
        title: '...',
        key: 'action',
        render: (text, station) => (<Dropdown placement="bottomRight" overlay={<Menu>< Menu.Item key = "0" > <StationLinkUpdate station={station} stations={stations} onUpdate={this.handleUpdate}/>
        </Menu.Item>
        {roleStationManagement(role) ? <Menu.Item key="1">
          <StationLinkGroupUpdate station={station} groups={groups} treeGroups={treeGroups} onUpdate={this.handleUpdate}/>
        </Menu.Item> : null}
        <Menu.Item key="2">
          <StationLinkCamera station={station} onStationButtonCamera={this.handleStationButtonCamera}/>
        </Menu.Item>
        {roleStationManagement(role) ? <Menu.Divider/> : null}
        {roleStationManagement(role) ? <Menu.Item key="3"><StationLinkDelete station={station} onDelete={this.handleDelete}/></Menu.Item> : null}
        </Menu >} trigger={['click']}>
          <a className="ant-dropdown-link" role="button">
            <Icon type="down"/>
          </a>
        </Dropdown>)
      }
    ];
    return <Table columns={columns} dataSource={stations} rowKey={station => station.ID} loading={fetching}/>
  }
}

export default StationTableMobile



// WEBPACK FOOTER //
// ./src/components/StationTableMobile.js